import { BUILD_CURRENCY_FORMAT_CONSTANTS as constants} from './build-currency-format.constants';

/**
 * Builds appropriate format for displaying a currency value
 * @param value Value to be formatted
 * @param thousandSeparator Symbol used to separate thousand units
 * @param decimalSeparator Symbol used to separate decimal units
 * @param currencySymbol
 * @param hideDecimals hide/display decimals.
 * @param locale Locale to format correctly th currency and default value.
 */
export function buildCurrencyFormat(
    value: number,
    thousandSeparator: string,
    decimalSeparator: string,
    currencySymbol: string,
    hideDecimals = false,
    locale: string = constants.DEFAULT_LOCALE
): string {
    const total = hideDecimals ? Math.round(value) : value;
    const numParseFloat = hideDecimals ? String(total) : total.toFixed(2);
    const numParts = numParseFloat.split('.');

    let formattedIntegerPart = Number(numParts[0]).toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    formattedIntegerPart = formattedIntegerPart.replace(/[^0-9]/g, thousandSeparator);

    if (numParts[1] && !hideDecimals) {
        formattedIntegerPart += decimalSeparator + numParts[1];
    }

    return `${currencySymbol}${formattedIntegerPart}`;
}
